// extracted by mini-css-extract-plugin
export default {"wrapperInputForm":"InputForm_wrapperInputForm__OI1EH","input":"InputForm_input__zD0Qy","errors":"InputForm_errors__aoBAd"};